import { geographyFrameMapping, LocationFilter } from '../models/LocationFilter';

export function getLocations(state, locations: LocationFilter[], locationLevel: string, locale: string) {
  const mutableState = state;
  let geographyMapping = geographyFrameMapping.get(locale);
  let location = geographyMapping.get(locationLevel);
  mutableState[location] = locations.map((location) => location.location);
  return mutableState;
}
